import { useAppSelector } from 'app/hooks';
import { hasEntitlementAccess } from 'utils';
import {
  selectIsUserAgent,
  selectUserFeatures,
} from 'services/session/sessionSelectors';
import { SERVICE_ENTITLEMENTS_MAPPING } from 'utils/service-entitlements-config';
import type { ServicesType } from 'utils/globalTypes';

function useIsFeatureAvailable(
  service: ServicesType | string[],
  agentCheckRequired = true,
) {
  const userFeatures = useAppSelector(selectUserFeatures);
  const isAgent = useAppSelector(selectIsUserAgent);

  const entitlements = Array.isArray(service)
    ? service
    : SERVICE_ENTITLEMENTS_MAPPING[service as ServicesType];

  return hasEntitlementAccess({
    userFeatures,
    entitlements,
    isAgent,
    agentCheckRequired,
  });
}

export default useIsFeatureAvailable;
